import { sessionStorageGet, sessionStorageSet } from './index'

const TOUR_PAGE_PARAM = 'TOUR_PAGE_PARAM'
const TOUR_FROM_VIEW = 'TOUR_FROM_VIEW'
//设置页面参数
export function setPageParamSession(data){
    sessionStorageSet(TOUR_PAGE_PARAM,data)
}
//获取页面参数
export function getPageParamSession(data){
    return sessionStorageGet(TOUR_PAGE_PARAM,data)
}
//设置来源页面
export function setFromView(data){
    sessionStorageSet(TOUR_FROM_VIEW,data)
}
//获取来源页面
export function getFromView(data){
    return sessionStorageGet(TOUR_FROM_VIEW,data)
}